import React, { useState } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Box, Button, Chip, Paper, TablePagination } from '@material-ui/core'

import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from 'components/Table'
import { MenuButton } from 'components'

import useStyles from './styles'

const SupplierQuestionsTable = ({
  questions = [],
  isLoading = false,
  onAnswerClick,
}) => {
  const classes = useStyles()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const paginatedQuestions = questions.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  )

  const getStatusChip = (question) => {
    const isAnswered = !!question.answer
    return (
      <Chip
        size="small"
        label={isAnswered ? 'Respondida' : 'Pendente'}
        className={isAnswered ? classes.answeredChip : classes.pendingChip}
      />
    )
  }

  return (
    <Paper variant="outlined">
      <PerfectScrollbar options={{ useBothWheelAxes: true }}>
        <Table
          emptyMessage="Nenhuma questão encontrada"
          isLoading={isLoading}
          noWrap
        >
          <TableHead>
            <TableRow>
              <TableCell width="35%">Pergunta</TableCell>
              <TableCell width="20%">Tema</TableCell>
              <TableCell width="25%">Resposta</TableCell>
              <TableCell width="10%" align="center">
                Status
              </TableCell>
              <TableCell width="10%" align="right">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedQuestions.map((question) => (
              <TableRow key={question?.id}>
                <TableCell>
                  <Box className={classes.questionText}>
                    {question?.question}
                  </Box>
                </TableCell>
                <TableCell>{question?.theme}</TableCell>
                <TableCell>{question?.answer}</TableCell>
                <TableCell align="center">{getStatusChip(question)}</TableCell>
                <TableCell align="right">
                  <MenuButton>
                    <Button
                      color="secondary"
                      fullWidth
                      size="small"
                      onClick={() => onAnswerClick(question)}
                    >
                      {!!question?.answer ? 'Editar' : 'Responder'}
                    </Button>
                  </MenuButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={questions.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Linhas por página"
      />
    </Paper>
  )
}

export default SupplierQuestionsTable
